import React, { useEffect, useState } from "react";
import { useSearchParams, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./productDetail.css";
import { toast } from "react-toastify";
import { getGuestCart, setGuestCart } from "../Cart/cartStorage";
import { Helmet } from "react-helmet";

function ProductDetail() {
  const { id: paramId } = useParams();
  const [searchParams] = useSearchParams();
  const id = paramId || searchParams.get("id");
  const navigate = useNavigate();
  // const id = searchParams.get("id");
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [plateNumber, setPlateNumber] = useState("");
  const [isZoomed, setIsZoomed] = useState(false);
  const [origin, setOrigin] = useState("center center");
  const [plateError, setPlateError] = useState(false);
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [qty, setQty] = useState(1);
  const [loading, setLoading] = useState(true);
  const [colorError, setColorError] = useState(false);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const today = new Date();
  const [selectedSize, setSelectedSize] = useState(null);
  const [sizeError, setSizeError] = useState(false);
  const deliveryDate = new Date();
  deliveryDate.setDate(today.getDate() + 4);

  const formatDate = (date) =>
    date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
    });

  const todayText = formatDate(today);
  const deliveryText = formatDate(deliveryDate);
  const reviewsToShow = showAllReviews
    ? product?.reviews
    : product?.reviews?.slice(0, 3);






  useEffect(() => {
    if (!id) return;
    setLoading(true);
    window.scrollTo(0, 0); // Scroll to top when loading a new product
    axiosInstance
      .get(`/products/?id=${id}`)
      .then((res) => {
        setProduct(res.data);

        if (res.data?.images?.length > 0) {
          setMainImage(res.data.images[0].image);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));

  }, [id]);
  useEffect(() => {
    if (!product) return;

    const schema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: product.product_title,
      image: product.images?.map(img => `https://stickyroot.in${img.image}`),
      description: product.product_details?.replace(/<[^>]+>/g, "") || "",
      sku: product.id,
      brand: { "@type": "Brand", name: "StickyRoot" },
      offers: {
        "@type": "Offer",
        url: `https://www.stickyroot.in/product/${product.id}`,
        priceCurrency: "INR",
        price: displayPrice,
        priceValidUntil: "2026-12-31",
        availability: "http://schema.org/InStock",
      },
      aggregateRating: product.reviews?.length
        ? {
          "@type": "AggregateRating",
          ratingValue:
            product.reviews.reduce((a, b) => a + b.rating, 0) /
            product.reviews.length,
          reviewCount: product.reviews.length,
        }
        : undefined,
      review: product.reviews?.map((r) => ({
        "@type": "Review",
        author: r.user_name,
        datePublished: r.created_at,
        reviewBody: r.comment,
        name: `${product.product_title} Review`,
        reviewRating: { "@type": "Rating", ratingValue: r.rating },
      })),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => document.head.removeChild(script);
  }, [product]);
useEffect(() => {
  const categoryId = product?.category?.[0]?.id;
  if (!categoryId) return;

  axiosInstance
    .get(`/products/?category=${categoryId}&limit=30`)
    .then((res) => {
      const filtered = res.data.results.filter(
        (item) => item.id !== product.id
      );

      setRelatedProducts(filtered.slice(0, 25));
    })
    .catch((err) => console.log(err));
}, [product]);
  useEffect(() => {
    if (product) {
      document.title = `${product.product_title} | StickyRoot`;
      const metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          product.product_details?.replace(/<[^>]+>/g, "").slice(0, 160)
        );
      }
    }
  }, [product]);

  useEffect(() => {
    if (!product?.category?.id) return;

    axiosInstance
      .get(`/products/?category=${product.category.id}&limit=30`)
      .then((res) => {
        const filtered = res.data.results.filter(
          (item) => item.id !== product.id
        );

        setRelatedProducts(filtered.slice(0, 25));
      })
      .catch((err) => console.log(err));
  }, [product]);



  const categoryName = product?.category?.name?.toLowerCase();
  const isCustomTextProduct =
    categoryName === "number plate" ||
    categoryName === "name board";
  const handleAddToCart = () => {
    if (!product) return;

    const token = localStorage.getItem("access");

    if (token) {
      axiosInstance
        .post("/cart/cart/", {
          product: product.id,
          quantity: qty,
          color: selectedColor?.id || null,
          size: selectedSize ? selectedSize.id : null,
          number_plate: plateNumber || null,
        })
        .then(() => {
          toast.success("Added ❤️");
          window.dispatchEvent(new Event("cartUpdated"));
          navigate("/cart");
        })
        .catch(() => toast.error("Failed ❌"));
    } else {
      const cart = getGuestCart();
      const existing = cart.find(
        (i) =>
          i.product_id === product.id &&
          i.size?.id === selectedSize?.id &&
          i.color?.id === selectedColor?.id &&
          i.number_plate === (plateNumber || null)
      );

if (existing) {
  existing.quantity += qty;
} else {
  cart.push({
    product_id: product.id,
    quantity: qty,
    price: displayPrice,
    title: product.product_title,
    image: product.images?.[0]?.image || "",
    category: product?.category?.name || "",

    size: selectedSize
      ? {
          id: selectedSize.id,
          size: selectedSize.size,
          price: selectedSize.price,
        }
      : null,

    color: selectedColor
      ? {
          id: selectedColor.id,
          name: selectedColor.name,
          hex_code: selectedColor.hex_code,
        }
      : null,

    number_plate: plateNumber || null,
  });
}

      setGuestCart(cart);
      window.dispatchEvent(new Event("cartUpdated"));
      toast.success("Added ❤️");
      navigate("/cart");
    }
  };
  useEffect(() => {
    if (product?.sizes?.length > 0) {
      setSelectedSize(product.sizes[0]);
    }
  }, [product]);
  const displayPrice =
    selectedSize?.price ||
    product?.price ||
    product?.sizes?.[0]?.price ||
    0;
  const scrollSlider = (direction) => {
    const container = document.getElementById("relatedSlider");
    if (!container) return;

    const scrollAmount = 320;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const handleBuyNow = () => {
    if (!product) return;
    if (product.sizes?.length > 0 && !selectedSize) {
      setSizeError(true);
      setTimeout(() => setSizeError(false), 1500);
      toast.error("Please select size");
      return;
    }
    if (product.colors?.length > 0 && !selectedColor) {
      setColorError(true);
      setTimeout(() => setColorError(false), 1500);
      toast.error("Please select color");
      return;
    }
    if (isCustomTextProduct && !plateNumber.trim()) {
      setPlateError(true);
      setTimeout(() => setPlateError(false), 1500);
      toast.error("Please enter required text");
      return;
    }
    const isLoggedIn = !!localStorage.getItem("access");
    const buyNowCart = [
      {
        product_id: product.id,
        quantity: qty,
        price: displayPrice,
        title: product.product_title,
        image: product.images?.[0]?.image || "",
        category: product?.category?.name || "",

        size: selectedSize
          ? {
            id: selectedSize.id,
            name: selectedSize.size,
            price: selectedSize.price,
          }
          : null,

        color: selectedColor
          ? {
            id: selectedColor.id,
            name: selectedColor.name,
            hex_code: selectedColor.hex_code,
          }
          : null,

        number_plate: plateNumber || null,
      },
    ];
    const total = displayPrice * qty;
    if (!isLoggedIn) {
      navigate("/login", {
        state: { from: "/checkout", cart: buyNowCart, total, isBuyNow: true },
      });
      return;
    }
    navigate("/checkout", {
      state: { cart: buyNowCart, total, isBuyNow: true },
    });
  };
  // ================= LOADING STATE =================
  if (loading) {
    return (
      <div className="detail-container">
        <div className="detail-wrapper">
          {/* Left Side: Image Skeleton */}
          <div className="image-section">
            <div className="skeleton skeleton-main-img"></div>
            <div className="thumb-row" style={{ marginTop: '10px' }}>
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="skeleton skeleton-thumb"></div>
              ))}
            </div>
            <div className="btn-row" style={{ marginTop: '20px' }}>
              <div className="skeleton skeleton-action-btn"></div>
              <div className="skeleton skeleton-action-btn"></div>
            </div>
          </div>

          {/* Right Side: Info Skeleton */}
          <div className="info-section">
            <div className="skeleton skeleton-title"></div>
            <div className="skeleton skeleton-price-bar"></div>

            <div style={{ marginTop: '30px' }}>
              <div className="skeleton skeleton-text-line"></div>
              <div className="skeleton skeleton-text-line" style={{ width: '80%' }}></div>
              <div className="skeleton skeleton-text-line" style={{ width: '90%' }}></div>
            </div>

            <div style={{ marginTop: '40px' }}>
              <div className="skeleton skeleton-title" style={{ width: '40%' }}></div>
              <div className="skeleton skeleton-text-line"></div>
              <div className="skeleton skeleton-text-line"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!product) return <div style={{ padding: 40 }}>Product not found</div>;
  return (
    <>

      <Helmet>
        <title>{product?.product_title} | StickyRoot</title>
        <meta name="description" content={product?.product_details?.replace(/<[^>]+>/g, "")} />
        <meta property="og:title" content={product?.product_title} />
        <meta property="og:description" content={product?.product_details?.replace(/<[^>]+>/g, "")} />
        <meta property="og:image" content={product?.images?.[0]?.image} />
        <meta property="og:url" content={`https://stickyroot.in/product/${product?.id}`} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="detail-container">
        <div className="detail-wrapper">
          <div className="image-section">
            <div
              className="zoom-container"
              onClick={() => setIsZoomed(!isZoomed)}
              onMouseMove={(e) => {
                if (!isZoomed) return;

                const { left, top, width, height } =
                  e.currentTarget.getBoundingClientRect();
                const x = ((e.clientX - left) / width) * 100;
                const y = ((e.clientY - top) / height) * 100;

                setOrigin(`${x}% ${y}%`);
              }}
              onMouseLeave={() => setOrigin("center center")}
            >
              <img
                src={mainImage}
                loading="lazy"
                alt={`Thumbnail of ${product.product_title}`}
                className={`zoom-img ${isZoomed ? "zoomed" : ""}`}
                style={{ transformOrigin: origin }}
              />
            </div>
            <div className="thumb-row">
              {product.images?.map((img) => (
                <img
                  key={img.id}
                  src={img.image}
                  className="thumb-img"
                  alt=""
                  onClick={() => setMainImage(img.image)}
                />
              ))}
            </div>
            <div className="btn-row">
              <button className="add-btn" onClick={handleAddToCart}>
                Add to Cart
              </button>
              <button className="buy-btn" onClick={handleBuyNow}>
                Buy Now
              </button>
            </div>
          </div>
          <div className="info-section">
            <h2>{product.product_title}</h2>

            <div className="detail-price-section">
              {(() => {
                const discountPercent = 20;
                const price = displayPrice;

                const originalPrice = Math.round(
                  price / (1 - discountPercent / 100)
                );

                return (
                  <>
                    <span className="detail-discount-badge">
                      {discountPercent}% OFF
                    </span>

                    <span className="detail-original-price">
                      ₹{originalPrice.toLocaleString()}
                    </span>

                    <span className="detail-final-price">
                      ₹{price.toLocaleString()}
                    </span>
                  </>
                );
              })()}
            </div>
            {product.sizes?.length > 0 && (
              <div className={sizeError ? "size-error-blink" : ""} style={{ marginTop: 15 }}>
                <p><b>Select Size:</b></p>

                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {product.sizes.map((size) => (
                    <button
                      key={size.id}
                      onClick={() => setSelectedSize(size)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border:
                          selectedSize?.id === size.id
                            ? "2px solid black"
                            : "1px solid #ccc",
                        background:
                          selectedSize?.id === size.id ? "#f5f5f5" : "white",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      {size.size}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div className="qty-box">
              <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>
            {product.colors?.length > 0 && (
              <div className={colorError ? "color-error-blink" : ""}>
                <p><b>Select Color:</b></p>
                <div style={{ display: "flex", gap: 10 }}>
                  {product.colors.map((color) => (
                    <div
                      key={color.id}
                      onClick={() => setSelectedColor(color)}
                      style={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        backgroundColor: color.hex_code,
                        border:
                          selectedColor?.id === color.id
                            ? "3px solid black"
                            : "1px solid #ccc",
                        cursor: "pointer",
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
            {isCustomTextProduct && (
              <div
                style={{ marginTop: 15 }}
                className={plateError ? "plate-error-blink" : ""}
              >
                <p>
                  <b>
                    {categoryName === "number plate"
                      ? "Enter Vehicle Number Plate:"
                      : "Enter Name Board Text:"}
                  </b>
                </p>
                {categoryName === "number plate" ? (
                  <input
                    type="text"
                    placeholder="TN48AZ0123"
                    value={plateNumber}
                    onChange={(e) =>
                      setPlateNumber(
                        e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "")
                      )
                    }
                    style={{
                      padding: "8px",
                      width: "250px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                ) : (
                  <textarea
                    placeholder="Enter Name Board Text"
                    value={plateNumber}
                    onChange={(e) => setPlateNumber(e.target.value)}
                    rows={4}
                    style={{
                      padding: "8px",
                      width: "300px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      resize: "none",
                    }}
                  />
                )}
              </div>
            )}
            <h2>About this:</h2>
            <div
              className="product-details"
              dangerouslySetInnerHTML={{
                __html: product.product_details,
              }}
            />
            <div className="delivery-info">
              🚚 <b>Expected Delivery: {deliveryText}</b> (Order today: {todayText})
            </div>
            <div className="review-section">

              <h3>Customer Reviews</h3>

              {product.reviews?.length === 0 && (
                <p>No reviews yet</p>
              )}

              {reviewsToShow?.map((review) => (
                <div key={review.id} className="review-card">

                  <div className="review-header">
                    <strong>{review.user_name}</strong>
                    <span className="review-stars">
                      {"⭐".repeat(review.rating)}
                    </span>
                  </div>

                  <p className="review-comment">{review.comment}</p>

                  <small>
                    {new Date(review.created_at).toLocaleDateString()}
                  </small>

                </div>
              ))}
              {product?.reviews?.length > 3 && (
                <button
                  className="view-more-btn"
                  onClick={() => setShowAllReviews(!showAllReviews)}
                >
                  {showAllReviews ? "View Less" : "View More Reviews"}
                </button>
              )}
            </div>
          </div>
        </div>
        {relatedProducts.length > 0 && (
          <div className="product-container" style={{ marginTop: 60 }}>
            <h2 >
              <span>Similar Products</span>
            </h2>
            <div className="related-slider-wrapper">
              {/* <button
                className="slider-btn left"
                onClick={() => scrollSlider("left")}
              >
                ❮
              </button> */}
              <div className="related-slider" id="relatedSlider">
                {relatedProducts.map((item) => {
                  const discountPercent = 20
                  const price = item.price || item.sizes?.[0]?.price || 0;

                  const originalPrice = Math.round(
                    price / (1 - discountPercent / 100)
                  );
                  return (
                    <div
                      key={item.id}
                      className="product-card"
                      onClick={() => navigate(`/product/${item.id}`)}
                    >
                      <img
                        src={item.images?.[0]?.image}
                        alt=""
                        className="card-img"
                      />
                      <h4 className="card-name">{item.product_title}</h4>
                      <div className="price-section">
  <span className="original-price">
    ₹{originalPrice.toLocaleString()}
  </span>

  <span className="discounted-price">
    ₹{price.toLocaleString()}
  </span>

  <span className="discount-badge">
    {discountPercent}% OFF
  </span>
</div>
                      <button
                        className="add-cart-btn"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent parent click
                          navigate(`/product/${item.id}`); // actually navigate
                        }}
                      >
                        View Product
                      </button>
                    </div>
                  );
                })}
              </div>
              {/* <button
                className="slider-btn right"
                onClick={() => scrollSlider("right")}
              >
                ❯
              </button> */}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductDetail;